export const REFRESH_TOKEN_KEY = '__refresh_token__';
export const SPACE_KEY = '__space__';
export const EXPIRE_DATE_KEY = '__expire_date__';
export const USER_PROFILE = process.env.REACT_APP_USER_PROFILE || '__user_profile__';
